<script setup lang="ts">
import { useUsersStore } from "@/stores/v2";
import { computed } from "vue";

const userStore = useUsersStore();

const loggedInUser = computed(() => userStore.getCurrentUser);
</script>

<template>
  <footer style="background: linear-gradient(180deg, #1d242c, #1f2937)"
    class="py-1 px-2 flex items-center justify-between bg-primary text-xs text-white">
    <p>
      Logged in as <strong>{{ loggedInUser?.name }}</strong>
    </p>
    <p>Version: 0.0.1</p>
  </footer>
</template>
